import { get, call } from 'vuex-pathify'
import { filter, first, flatten, map } from 'lodash-es'

export default {
  computed: {
    ...get({
      sortedCategories: 'kintell/sortedCategories',
      isCategoriesLoading: 'kintell/categoriesLoading'
    }),
    flattenedCategories () {
      return flatten(map(this.sortedCategories, category => category.children))
    }
  },
  methods: {
    ...call({
      loadCategories: 'kintell/loadCategories'
    }),
    findCategory (id) {
      return first(filter(this.flattenedCategories, category => category.id === id))
    }
  },
  mounted () {
    this.loadCategories()
  }
}
